import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyCreatePayment = lazyWithRetry(() => import("./CreatePayment"));

const CreatePayment = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyCreatePayment {...props} />;

export default CreatePayment;
